module.exports = __webpack_public_path__ + "static/media/ShiftIcon.3d11f5a0.png";